module.exports = __webpack_public_path__ + "img/social.bf35cb8e.png";